import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

import { BACKEND_URL, apiPath } from '../config/apiBase';
const API = apiPath('/api');

export default function SetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) { setError('Missing or invalid link.'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/set-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Could not set password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={wrap}>
      <div style={cardBox}>
        <h2 style={{ fontSize: '15px', fontWeight: 700, margin: '0 0 6px', color: '#111827' }}>Set your password</h2>
        {done ? (
          <div>
            <p style={{ color: '#065F46', background: '#D1FAE5', padding: '6px 10px', borderRadius: '8px', fontSize: '12px' }}>
              Password set successfully. Redirecting to sign in…
            </p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p style={{ color: '#6B7280', fontSize: '12px', margin: '0 0 18px' }}>
              Choose a password to access WorkflowDesk. You'll sign in with your email and this password.
            </p>
            {error && (
              <div style={{ background: '#FEE2E2', color: '#B91C1C', padding: '10px 14px', borderRadius: '8px', fontSize: '12px', marginBottom: '14px' }}>
                {error}
              </div>
            )}
            <label style={label}>New password</label>
            <input type="password" style={input} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" />
            <label style={label}>Confirm password</label>
            <input type="password" style={input} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            <button type="submit" disabled={busy} style={{ ...btn, opacity: busy ? 0.7 : 1 }}>
              {busy ? 'Saving…' : 'Set password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const wrap = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F3F4F6', padding: '10px' };
const cardBox = { background: 'white', borderRadius: '14px', padding: '32px', width: '100%', maxWidth: '420px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' };
const label = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', margin: '12px 0 6px' };
const input = { width: '100%', padding: '11px 12px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '12px', boxSizing: 'border-box' };
const btn = { width: '100%', marginTop: '20px', padding: '12px', background: '#002FA7', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '15px', cursor: 'pointer' };
